// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.audit-modal {
  max-width: 800px;
  width: 95%;
}

.audit-timeline {
  position: relative;
  padding: 20px 0;
}

.audit-timeline::before {
  content: '';
  position: absolute;
  left: 20px;
  top: 0;
  bottom: 0;
  width: 2px;
  background-color: #dee2e6;
}

.audit-entry {
  position: relative;
  margin-bottom: 30px;
  padding-left: 60px;
}

.audit-timeline-dot {
  position: absolute;
  left: 12px;
  top: 5px;
  width: 16px;
  height: 16px;
  background-color: #007bff;
  border-radius: 50%;
  border: 3px solid #ffffff;
  box-shadow: 0 0 0 3px #dee2e6;
}

.audit-content {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 15px;
}

.audit-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.audit-date {
  font-weight: bold;
  color: #495057;
  font-size: 14px;
}

.audit-reviewer {
  font-size: 12px;
  color: #6c757d;
  font-style: italic;
}

.audit-status-change {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.status-badge {
  padding: 4px 8px;
  border-radius: 12px;
  color: white;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  display: inline-block;
  min-width: 60px; /* Ensure consistent minimum width */
  text-align: center; /* Center text within badge */
}

.arrow {
  font-weight: bold;
  color: #6c757d;
  font-size: 16px;
}

.audit-comments {
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 1.4;
}

.audit-comments strong {
  color: #495057;
}

.audit-corrections {
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 1.4;
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 4px;
  padding: 8px;
}

.audit-corrections strong {
  color: #856404;
}

.audit-duration {
  font-size: 12px;
  color: #6c757d;
}

.audit-duration strong {
  color: #495057;
}

/* Separator between main status and action history */
.audit-separator {
  display: flex;
  align-items: center;
  margin: 30px 0;
  padding: 0 20px;
}

.separator-line {
  flex: 1 1;
  height: 1px;
  background-color: #dee2e6;
}

.separator-text {
  padding: 0 15px;
  font-size: 12px;
  font-weight: bold;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background-color: white;
}

/* Different styling for main entries vs action entries */
.audit-main .audit-content {
  background-color: #e3f2fd;
  border-color: #2196f3;
  border-width: 2px;
}

.audit-main .audit-timeline-dot {
  background-color: #2196f3;
  width: 20px;
  height: 20px;
  left: 10px;
}

.audit-transition .audit-content {
  background-color: #f8f9fa;
  border-color: #dee2e6;
}

.audit-transition .audit-timeline-dot {
  background-color: #6c757d;
  width: 14px;
  height: 14px;
  left: 13px;
}

.audit-action strong {
  color: #1976d2;
}

.audit-transition-details {
  margin-top: 8px;
  font-size: 13px;
  line-height: 1.4;
  color: #495057;
}

.audit-transition-details strong {
  color: #6c757d;
}

/* Action Results Styling */
.audit-action-summary {
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 1.4;
}

.audit-action-summary strong {
  color: #495057;
}

.audit-action-results {
  margin-top: 8px;
}

.audit-action-results strong {
  color: #495057;
  display: block;
  margin-bottom: 4px;
}

.action-results-list {
  margin: 0;
  padding-left: 16px;
  list-style: none;
}

.result-item {
  margin-bottom: 4px;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 13px;
  line-height: 1.3;
  position: relative;
}

.result-item::before {
  content: '•';
  position: absolute;
  left: -12px;
  font-weight: bold;
}

/* Different result types */
.result-validation_issue {
  background-color: #fff3cd;
  border-left: 3px solid #ffc107;
  color: #856404;
}

.result-validation_issue::before {
  color: #ffc107;
}

.result-processing_error {
  background-color: #f8d7da;
  border-left: 3px solid #dc3545;
  color: #721c24;
}

.result-processing_error::before {
  color: #dc3545;
}

.result-success {
  background-color: #d4edda;
  border-left: 3px solid #28a745;
  color: #155724;
}

.result-success::before {
  color: #28a745;
}

.result-processing_success {
  background-color: #d4edda;
  border-left: 3px solid #28a745;
  color: #155724;
}

.result-processing_success::before {
  color: #28a745;
}

.result-approval {
  background-color: #d1ecf1;
  border-left: 3px solid #17a2b8;
  color: #0c5460;
}

.result-approval::before {
  color: #17a2b8;
}

.result-rejection_reason {
  background-color: #f8d7da;
  border-left: 3px solid #dc3545;
  color: #721c24;
}

.result-rejection_reason::before {
  color: #dc3545;
}

.result-user_correction {
  background-color: #e2e3e5;
  border-left: 3px solid #6c757d;
  color: #383d41;
}

.result-user_correction::before {
  color: #6c757d;
}

/* Responsive design */
@media (max-width: 768px) {
  .audit-modal {
    width: 98%;
    max-height: 90vh;
  }
  
  .audit-entry {
    padding-left: 50px;
  }
  
  .audit-timeline::before {
    left: 15px;
  }
  
  .audit-timeline-dot {
    left: 7px;
    width: 14px;
    height: 14px;
  }
  
  .audit-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }
  
  .audit-status-change {
    flex-wrap: wrap;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/AuditLog.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,SAAS;EACT,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe,EAAE,oCAAoC;EACrD,kBAAkB,EAAE,6BAA6B;AACnD;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,yDAAyD;AACzD;EACE,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;IACT,WAAW;IACX,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".audit-modal {\n  max-width: 800px;\n  width: 95%;\n}\n\n.audit-timeline {\n  position: relative;\n  padding: 20px 0;\n}\n\n.audit-timeline::before {\n  content: '';\n  position: absolute;\n  left: 20px;\n  top: 0;\n  bottom: 0;\n  width: 2px;\n  background-color: #dee2e6;\n}\n\n.audit-entry {\n  position: relative;\n  margin-bottom: 30px;\n  padding-left: 60px;\n}\n\n.audit-timeline-dot {\n  position: absolute;\n  left: 12px;\n  top: 5px;\n  width: 16px;\n  height: 16px;\n  background-color: #007bff;\n  border-radius: 50%;\n  border: 3px solid #ffffff;\n  box-shadow: 0 0 0 3px #dee2e6;\n}\n\n.audit-content {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  padding: 15px;\n}\n\n.audit-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.audit-date {\n  font-weight: bold;\n  color: #495057;\n  font-size: 14px;\n}\n\n.audit-reviewer {\n  font-size: 12px;\n  color: #6c757d;\n  font-style: italic;\n}\n\n.audit-status-change {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.status-badge {\n  padding: 4px 8px;\n  border-radius: 12px;\n  color: white;\n  font-size: 12px;\n  font-weight: bold;\n  text-transform: uppercase;\n  display: inline-block;\n  min-width: 60px; /* Ensure consistent minimum width */\n  text-align: center; /* Center text within badge */\n}\n\n.arrow {\n  font-weight: bold;\n  color: #6c757d;\n  font-size: 16px;\n}\n\n.audit-comments {\n  margin-bottom: 8px;\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n.audit-comments strong {\n  color: #495057;\n}\n\n.audit-corrections {\n  margin-bottom: 8px;\n  font-size: 14px;\n  line-height: 1.4;\n  background-color: #fff3cd;\n  border: 1px solid #ffeaa7;\n  border-radius: 4px;\n  padding: 8px;\n}\n\n.audit-corrections strong {\n  color: #856404;\n}\n\n.audit-duration {\n  font-size: 12px;\n  color: #6c757d;\n}\n\n.audit-duration strong {\n  color: #495057;\n}\n\n/* Separator between main status and action history */\n.audit-separator {\n  display: flex;\n  align-items: center;\n  margin: 30px 0;\n  padding: 0 20px;\n}\n\n.separator-line {\n  flex: 1;\n  height: 1px;\n  background-color: #dee2e6;\n}\n\n.separator-text {\n  padding: 0 15px;\n  font-size: 12px;\n  font-weight: bold;\n  color: #6c757d;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  background-color: white;\n}\n\n/* Different styling for main entries vs action entries */\n.audit-main .audit-content {\n  background-color: #e3f2fd;\n  border-color: #2196f3;\n  border-width: 2px;\n}\n\n.audit-main .audit-timeline-dot {\n  background-color: #2196f3;\n  width: 20px;\n  height: 20px;\n  left: 10px;\n}\n\n.audit-transition .audit-content {\n  background-color: #f8f9fa;\n  border-color: #dee2e6;\n}\n\n.audit-transition .audit-timeline-dot {\n  background-color: #6c757d;\n  width: 14px;\n  height: 14px;\n  left: 13px;\n}\n\n.audit-action strong {\n  color: #1976d2;\n}\n\n.audit-transition-details {\n  margin-top: 8px;\n  font-size: 13px;\n  line-height: 1.4;\n  color: #495057;\n}\n\n.audit-transition-details strong {\n  color: #6c757d;\n}\n\n/* Action Results Styling */\n.audit-action-summary {\n  margin-bottom: 8px;\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n.audit-action-summary strong {\n  color: #495057;\n}\n\n.audit-action-results {\n  margin-top: 8px;\n}\n\n.audit-action-results strong {\n  color: #495057;\n  display: block;\n  margin-bottom: 4px;\n}\n\n.action-results-list {\n  margin: 0;\n  padding-left: 16px;\n  list-style: none;\n}\n\n.result-item {\n  margin-bottom: 4px;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 13px;\n  line-height: 1.3;\n  position: relative;\n}\n\n.result-item::before {\n  content: '•';\n  position: absolute;\n  left: -12px;\n  font-weight: bold;\n}\n\n/* Different result types */\n.result-validation_issue {\n  background-color: #fff3cd;\n  border-left: 3px solid #ffc107;\n  color: #856404;\n}\n\n.result-validation_issue::before {\n  color: #ffc107;\n}\n\n.result-processing_error {\n  background-color: #f8d7da;\n  border-left: 3px solid #dc3545;\n  color: #721c24;\n}\n\n.result-processing_error::before {\n  color: #dc3545;\n}\n\n.result-success {\n  background-color: #d4edda;\n  border-left: 3px solid #28a745;\n  color: #155724;\n}\n\n.result-success::before {\n  color: #28a745;\n}\n\n.result-processing_success {\n  background-color: #d4edda;\n  border-left: 3px solid #28a745;\n  color: #155724;\n}\n\n.result-processing_success::before {\n  color: #28a745;\n}\n\n.result-approval {\n  background-color: #d1ecf1;\n  border-left: 3px solid #17a2b8;\n  color: #0c5460;\n}\n\n.result-approval::before {\n  color: #17a2b8;\n}\n\n.result-rejection_reason {\n  background-color: #f8d7da;\n  border-left: 3px solid #dc3545;\n  color: #721c24;\n}\n\n.result-rejection_reason::before {\n  color: #dc3545;\n}\n\n.result-user_correction {\n  background-color: #e2e3e5;\n  border-left: 3px solid #6c757d;\n  color: #383d41;\n}\n\n.result-user_correction::before {\n  color: #6c757d;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .audit-modal {\n    width: 98%;\n    max-height: 90vh;\n  }\n  \n  .audit-entry {\n    padding-left: 50px;\n  }\n  \n  .audit-timeline::before {\n    left: 15px;\n  }\n  \n  .audit-timeline-dot {\n    left: 7px;\n    width: 14px;\n    height: 14px;\n  }\n  \n  .audit-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 5px;\n  }\n  \n  .audit-status-change {\n    flex-wrap: wrap;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
